var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSingleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 14,
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.00002 11.2L1.80002 6.99998L0.400025 8.39998L6.00002 14L18 1.99998L16.6 0.599975L6.00002 11.2Z",
  fill: "#02CA79"
})));
export { SvgSingleCheck as ReactComponent };
export default __webpack_public_path__ + "fe2717f977e1f79f7080e9bb26d4c42a.svg";